import { css } from '@emotion/react';

export const TextOverFlowCss = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
